import { siteContent } from '@/mocks/pt/siteContent';

export default function AboutSection() {
  const { eeat } = siteContent;

  return (
    <section className="px-4 md:px-6 py-16 md:py-20 bg-accent-50/60">
      <div className="max-w-7xl mx-auto">
        {/* Label */}
        <span className="inline-block px-4 py-1.5 text-xs font-semibold bg-accent-100 text-accent-800 rounded-full mb-5 whitespace-nowrap">
          {eeat.label}
        </span>

        {/* Title */}
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-12 leading-tight">
          {eeat.title}
        </h2>

        {/* Trust Points */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-14">
          {eeat.points.map((point, i) => (
            <div key={i} className="flex items-start gap-3">
              <div className="w-8 h-8 rounded-full bg-accent-200 flex items-center justify-center flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-accent-700 text-sm w-4 h-4 flex items-center justify-center"></i>
              </div>
              <p className="text-sm text-foreground-700 leading-snug pt-1">{point}</p>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {eeat.stats.map((stat, i) => (
            <div key={i} className="text-center">
              <div className="text-3xl md:text-4xl font-extrabold text-foreground-900 mb-2">
                {stat.value}
              </div>
              <p className="text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}